export const REJECT_TYPE_OPTIONS = [
  { label: 'Shortage', value: 'shortage' },
  { label: 'Damage', value: 'damage' },
  { label: 'Other', value: 'other' },
];

export const getGrnRejectTypeBadgeColor = status => {
  switch (status) {
    case 'shortage':
      return 'warning';

    case 'damage':
      return 'danger';

    case 'other':
      return 'secondary';

    default:
      return 'secondary';
  }
};
